import React, { FC } from 'react';

import { EvFlexColumn, EvFlexRow, EvTitle } from '@evinced-private/ui-common';

import { DASHBOARD_LABELS } from '../../pages/dashboard/Dashboard.labels';
import { ScoreData } from '../../services/queries/score/helpers/transformResults';
import { AccessibilityCriticalIssuesStackedChartContainer } from '../accessibility-critical-issues-stacked-chart';
import { ChartIssuesInput } from '../accessibility-critical-issues-stacked-chart/types';
import { AccessibilityTrendsChartContainer } from '../accessibility-trends-chart/AccessibilityTrendsChartContainer';
import { DashboardChartWrapper } from '../dashboard-chart-wrapper';

interface BusinessUnitChartsSectionProps {
	uniqueIssuesData?: ChartIssuesInput;
	isDashboardDataLoading: boolean;
	dashboardDataError: unknown;
	scoreData?: ScoreData[];
	isScoreDataLoading?: boolean;
	scoreDataError?: unknown;
	dashboardData?: ChartIssuesInput;
}

export const BusinessUnitChartsSection: FC<BusinessUnitChartsSectionProps> = ({
	uniqueIssuesData,
	isDashboardDataLoading,
	dashboardDataError,
	scoreData,
	isScoreDataLoading,
	scoreDataError,
	dashboardData
}) => {
	return (
		<EvFlexColumn gap="LARGE" role="group" ariaLabelledby="trends-heading">
			<EvTitle id="trends-heading" titleText={DASHBOARD_LABELS.ACCESSIBILITY_PERFORMANCE_TRENDS} />
			<EvFlexRow gap="XLARGE">
				<DashboardChartWrapper>
					<AccessibilityTrendsChartContainer
						scoreData={scoreData}
						isLoading={isScoreDataLoading}
						error={scoreDataError}
					/>
				</DashboardChartWrapper>
				<DashboardChartWrapper>
					<AccessibilityCriticalIssuesStackedChartContainer
						data={dashboardData}
						uniqueIssuesData={uniqueIssuesData}
						isLoading={isDashboardDataLoading}
						error={dashboardDataError}
					/>
				</DashboardChartWrapper>
			</EvFlexRow>
		</EvFlexColumn>
	);
};
